import { Component, OnInit, ViewChild, HostListener } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { SessionService } from 'src/app/shared/_service/session.service';
import { AuthService } from 'src/app/auth/_service/auth.service';
import { ProductService } from 'src/app/shared/_service/product.service';
import { TranslateService } from '@ngx-translate/core';
import { ValueConverter } from '@angular/compiler/src/render3/view/template';

@Component({
	selector: 'app-header',
	templateUrl: './header.component.html',
})
export class HeaderComponent implements OnInit {
	constructor(
		private router: Router,
		private session: SessionService,
		private auth: AuthService,
		private productService: ProductService,
		private translate: TranslateService,
	) {}

	menuOpen = null;
	carrello = 0;
	utente = this.auth.getUser();

	@ViewChild('tendina', { static: false }) tendina;

	menus: any = [
		{
			offset: '-10px',
			voci: [
				{ nome: 'Orders', url: '/orders' },
				{ nome: 'Tracking', url: '/tracking' },
			],
		},
		{
			offset: '85px',
			voci: [
				{ nome: 'Profile', url: '/profile' },
				{ nome: 'Logout', url: '/logout' },
			],
		},
		{
			idMenu: 'serie',
			offset: '130px',
			voci: [
				{
					nome: 'MC_P-Cod.Serie1|+0609',
					url: '/series',
					id: 'MC_P-Cod.Serie1|+0609;MC_P-Cod.Serie1|+1099;MC_P-Cod.Serie1|+1599;MC_P-Cod.Serie1|+2599;MC_P-Cod.Serie1|+4599;MC_P-Cod.Serie1|+8099',
				},
				{
					nome: 'MC_P-Cod.Serie1|+0604',
					url: '/series',
					id: 'MC_P-Cod.Serie1|+0604;MC_P-Cod.Serie1|+1101;MC_P-Cod.Serie1|+1601;MC_P-Cod.Serie1|+2600;MC_P-Cod.Serie1|+4601;MC_P-Cod.Serie1|+8101',
				},
				{
					nome: 'MC_P-Cod.Serie1|+0603',
					url: '/series',
					id: 'MC_P-Cod.Serie1|+0603;MC_P-Cod.Serie1|+1102;MC_P-Cod.Serie1|+1602;MC_P-Cod.Serie1|+2601;MC_P-Cod.Serie1|+4602;MC_P-Cod.Serie1|+8102',
				},
				{ nome: 'MC_P-Cod.Serie1|+0599', url: '/series', id: 'MC_P-Cod.Serie1|+0599;MC_P-Cod.Serie1|+4604;MC_P-Cod.Serie1|+8104;' },
				{
					nome: 'MC_P-Cod.Serie1|+0602',
					url: '/series',
					id: 'MC_P-Cod.Serie1|+0602;MC_P-Cod.Serie1|+1104;MC_P-Cod.Serie1|+1604;MC_P-Cod.Serie1|+4605;MC_P-Cod.Serie1|+8105;',
				},
				{ nome: 'MC_P-Cod.Serie1|+0608', url: '/series', id: 'MC_P-Cod.Serie1|+0608;MC_P-Cod.Serie1|+4606;MC_P-Cod.Serie1|+8106;' },
				{ nome: 'MC_P-Cod.Serie1|+0610', url: '/series', id: 'MC_P-Cod.Serie1|+0610;MC_P-Cod.Serie1|+4608;MC_P-Cod.Serie1|+8108;' },
			],
		},
		{
			idMenu: 'categorie',
			offset: '205px',
			voci: [
				{ nome: 'MC_P-CodLineaProdotto|05', url: '/category', id: 'MC_P-CodLineaProdotto|05' },
				{ nome: 'MC_P-CodLineaProdotto|15', url: '/category', id: 'MC_P-CodLineaProdotto|15' },
				{ nome: 'MC_P-CodLineaProdotto|10', url: '/category', id: 'MC_P-CodLineaProdotto|10' },
				{ nome: 'MC_P-CodLineaProdotto|80', url: '/category', id: 'MC_P-CodLineaProdotto|80' },
				{ nome: 'MC_P-CodLineaProdotto|25', url: '/category', id: 'MC_P-CodLineaProdotto|25' },
				{ nome: 'MC_P-CodLineaProdotto|45', url: '/category', id: 'MC_P-CodLineaProdotto|45' },
				{ nome: 'MC_P-CodLineaProdotto|81', url: '/category', id: 'MC_P-CodLineaProdotto|81' },
				{ nome: 'Accessories', url: '/accessori' },
			],
		},
	];

	ngOnInit() {
		this.router.events.subscribe((event) => {
			if (event instanceof NavigationEnd) {
				this.close();
			}
		});

		this.session.carrelloChange.subscribe((c) => {
			this.carrello = 0;
			c.forEach((prodotto) => {
				this.carrello += prodotto.quantita;
			});
		});

		if (this.auth.isAdminOrBackoffice) {
			this.menus[0].voci = [
				{ nome: 'Order Management', url: '/ordini-cms' },
				{ nome: 'Tracking users', url: '/tracking' },
				{ nome: 'Product visibility error control', url: '/controllo-errori-visibilita-prodotti' },
			];

			if (this.auth.isAdmin) {
				this.menus[0].voci.push({ nome: 'Customer configuration', url: '/configurazione-cliente' });
				this.menus[0].voci.push({ nome: 'Portal user configuration', url: '/configurazione-utente' });
				this.menus[0].voci.push({ nome: 'Color configuration', url: '/configurazione-colori' });
				// this.menus[0].voci.push({ nome: 'Configurazione containerizzatore', url: '/configurazione-containerizzatore' });
				this.menus[0].voci.push({ nome: 'Transcoding customer codes', url: '/transcodifica' });
				// this.menus[0].voci.push({ nome: 'Agenti e limiti sconto', url: '/configurazione-limite-sconti' });
				this.menus[0].voci.push({ nome: 'Company configuration', url: '/configurazione-company' });
			}
		}

		if (this.auth.isAgente) {
			this.menus[0].voci = [{ nome: 'Order Management', url: '/ordini-agente' }];
		}

		// if (this.auth.getUser().containerizzazioneCarrello || this.auth.getUser().containerizzazioneOrdini) {
		// 	this.menus[0].voci.push({ nome: 'Set up your Container', url: '/containers' });
		// }

		// if (this.auth.isSpedizioniere) {
		// 	this.menus[0].voci = [{ nome: 'Shipments', url: '/containers' }];
		// }

		// Aggiorno prima i prodotti in sessione
		this.session.getProdotti().subscribe((_) => {
			// Filtro le serie che non contengono prodotti e le rimuovo dal menu
			const menuSerie = this.menus.find((m) => m.idMenu === 'serie');
			menuSerie.voci.forEach((voce) => {
				if (!this.productService.isSeriePresente(voce.id)) {
					voce.hidden = true;
				}
			});
			menuSerie.voci = menuSerie.voci.filter((v) => !v.hidden);
			// Filtro le categorie che non contengono prodotti e le rimuovo dal menu
			const menuCategorie = this.menus.find((m) => m.idMenu === 'categorie');
			menuCategorie.voci.forEach((voce) => {
				if (voce.id && !this.productService.isCategoriaPresente(voce.id)) {
					voce.hidden = true;
				}
			});
			menuCategorie.voci = menuCategorie.voci.filter((v) => !v.hidden);
		});
	}

	open(menu, event) {
		this.menuOpen = this.menus[menu];
		event.stopPropagation();
	}

	cerca(event) {
		if (event.target.value) {
			this.router.navigate(['/search'], { queryParams: { q: event.target.value } });
			console.log(event.target.value);
		}
	}

	@HostListener('document:click', ['$event'])
	documentClick(event: MouseEvent) {
		if (this.menuOpen && !this.tendina.nativeElement.contains(event.target)) {
			this.close();
		}
	}

	close() {
		this.menuOpen = null;
	}
}
